import ScrollToTopOnMount from "../../components/ScrollToTopOnMount/ScrollToTopOnMount";
import Home from "../../layouts/Home/Home"

const Homepage = () => {
    return (
        <>
            <ScrollToTopOnMount />
            <Home />
        </>
    )
}

export default Homepage;